import SelectCollection from '@widesk-ui/components/form/SelectCollection';
import createSelect     from '@widesk-ui/tools/createSelect';
import FieldTypeModel   from '@models/map/FieldTypeModel';

const Select = createSelect<typeof FieldTypeModel>(props => (
	<SelectCollection
		modelClass={FieldTypeModel}
		renderOption={m => m.renderName()}
		sortName="id"
		sortWay="desc"

		{...props}
	/>
));

export default Select;